import { RichTextProps } from '@/components/molecules/richTextComponent'
import { Introduction } from './Introduction'
import { ButtonProps } from '@/components/atoms/button'
import {
  ClientEnvironmentContext,
  getGlobalEnvironmentConfig,
} from '@/utils/globalConfig'
import { useContext } from 'react'
import { BuildUmbracoUrl } from '@/utils/urlHelpers'

function introductionFactory(data: any, key: string | number) {
  const buttonData = data?.content?.properties?.button
  const richTextData = data?.content?.properties?.introductionText

  let buttonUrl: string | undefined =
    buttonData?.[0]?.route?.path ?? buttonData?.[0]?.url

  // Media URLs should be loaded from Umbraco instead of the frontend.
  if (buttonUrl && buttonUrl.substring(0, 7) === '/media/') {
    buttonUrl = BuildUmbracoUrl(buttonUrl)
  }

  const buttonProps: ButtonProps = {
    url: buttonUrl,
    text: buttonData?.[0]?.title,
  }

  const richTextProps: RichTextProps = {
    title: richTextData?.markup,
  }

  return (
    <Introduction
      key={key}
      buttonProps={buttonProps}
      richTextProps={richTextProps}
    />
  )
}
export default introductionFactory
